module.exports = __webpack_public_path__ + "static/img/qqhy.1baffa77.jpg";